export enum HeaderType {
  Verde = 'primary',
  Branco = 'secondary',
  Semi = 'semi',
  Assembleia = 'assembleia'
}
